import styles from './Suburbs.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import QualifiedLink from 'QualifiedLink/QualifiedLink';
import { ChevronIcon } from 'seek-style-guide/react';
import omit from 'lodash.omit';

const initiallyVisibleSuburbs = 5;

function mapStateToProps({ search, results }) {
  return {
    searchQuery: search.query,
    suburbs: results.results ? results.results.suburbs : []
  };
}

function removePage(query) {
  return omit(query, ['page']);
}

@connect(mapStateToProps)
export default class Suburbs extends Component {

  static propTypes = {
    searchQuery: PropTypes.object.isRequired,
    suburbs: PropTypes.array.isRequired
  };

  renderSuburb(searchQuery, length, suburb, index) {
    return (
      <span key={index}>
        <QualifiedLink
          className={styles.link}
          path="/jobs"
          aria-label={`Jobs in ${suburb}`}
          analytics={`search-by-suburb-${suburb}`}
          params={ { ...removePage(searchQuery), where: suburb } }
          scrollToTop={true}
          data-automation="suburb-link">
          {suburb}
        </QualifiedLink>
        {
          (index !== length - 1) ? (<span>,&nbsp;</span>) : null
        }
      </span>
    );
  }

  render() {
    const { suburbs, searchQuery } = this.props;

    if (!suburbs.length || suburbs.length < 2) {
      return null;
    }

    const topSuburbs = suburbs.slice(0, initiallyVisibleSuburbs);
    const remainingSuburbs = suburbs.slice(initiallyVisibleSuburbs);

    return (
      <section className={styles.root} data-automation="suburbs-container">
        <div className={styles.content}>
          <h2 className={styles.heading}>Refine by location </h2>
          <input id="expandSuburbs" type="checkbox" className={styles.toggle} />
          <div className={styles.suburbs}>
            {
              topSuburbs.map((suburb, index) => this.renderSuburb(searchQuery, topSuburbs.length, suburb, index))
            }

            {
              remainingSuburbs.length ? (
                <label htmlFor="expandSuburbs" className={`${styles.link} ${styles.toggleLabel}`}>
                  <span className={styles.more}>More</span>
                  <span className={styles.less}>Less</span>
                  <ChevronIcon direction="down" className={styles.chevron} svgClassName={styles.chevronSvg} />
                </label>
              ) : null
            }

            {
              remainingSuburbs.length ? (
                <div className={styles.toggleContent}>
                  {
                    remainingSuburbs.map((suburb, index) => this.renderSuburb(searchQuery, remainingSuburbs.length, suburb, index))
                  }
                </div>
              ) : null
            }
          </div>
        </div>
      </section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/Suburbs/Suburbs.js
 **/